import { Suspense, useState } from "react";
import { Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { StyledDialog } from "components/dialog/StyledDialog";
import { AddLayer } from "components/layer/AddLayer";
import { SelectPersonalLayer } from "./select/SelectPersonalLayer";
import { ListSkeleton } from "components/skeletons/ListSkeleton";
import { ErrorBoundary } from "react-error-boundary";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";

export function PersonalLayers() {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  return (
    <>
      <Link onClick={() => setIsDialogOpen(true)}>
        {t("label.addLayerYourself")}
      </Link>
      <StyledDialog
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
      >
        <Typography variant="h2" component="h2">
          {t("label.addPersonalLayer")}
        </Typography>
        <Suspense fallback={<ListSkeleton />}>
          <AddLayer setIsDialogOpen={setIsDialogOpen} />
        </Suspense>
      </StyledDialog>
      <ErrorBoundary FallbackComponent={AlertErrorBoundary}>
        <Suspense fallback={<ListSkeleton />}>
          <SelectPersonalLayer />
        </Suspense>
      </ErrorBoundary>
    </>
  );
}
